// Global events and functions

( function( $, window, document, undefined ) {

	$('a[href^="#"]').click( (event) => {

		let $target = $(event.target);

		if ( !$target.is('a') ) {
			$target = $target.closest('a');
		}

		let href = $target.attr('href');

		if ( '#' !== href && $(href).length ) {
			window.SmoothScroll.toElement( $(href) );
		}

		// Do not prevent default so that hash is added to browser URL

	} );

} )( jQuery, window, document );
